import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/outlayserv'

export default {
  state: {
    state_Outlay_AddObjResult: null,
    state_Outlay_GetAllResult: null,
    state_Outlay_GetPageResult: null,
    state_Outlay_GetDetailResult: null,
    state_Outlay_ModifyObjResult: null,
    state_Outlay_DeleteObjResult: null
  },
  mutations: {
    SET_OUTLAY_ADDOBJ_RESULT: (state, rst) => {
      state.state_Outlay_AddObjResult = rst
    },
    SET_OUTLAY_GETALL_RESULT: (state, rst) => {
      state.state_Outlay_GetAllResult = rst
    },
    SET_OUTLAY_GETPAGE_RESULT: (state, rst) => {
      state.state_Outlay_GetPageResult = rst
    },
    SET_OUTLAY_GETDETAIL_RESULT: (state, rst) => {
      state.state_Outlay_GetDetailResult = rst
    },
    SET_OUTLAY_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Outlay_ModifyObjResult = rst
    },
    SET_OUTLAY_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Outlay_DeleteObjResult = rst
    }
  },
  actions: {
    OutlayServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    OutlayServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    OutlayServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    OutlayServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    OutlayServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    OutlayServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_OUTLAY_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_OUTLAY_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Outlay_AddObjResult: state => {
      return state.state_Outlay_AddObjResult
    },
    get_Outlay_GetAllResult: state => {
      return state.state_Outlay_GetAllResult
    },
    get_Outlay_GetPageResult: state => {
      return state.state_Outlay_GetPageResult
    },
    get_Outlay_GetDetailResult: state => {
      return state.state_Outlay_GetDetailResult
    },
    get_Outlay_ModifyObjResult: state => {
      return state.state_Outlay_ModifyObjResult
    },
    get_Outlay_DeleteObjResult: state => {
      return state.state_Outlay_DeleteObjResult
    }
  }
}
